import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import ErrorInfo from '../../views/etc/ErrorInfo';

const NotFound = () => {
  const content = '요청하신 페이지를 찾을 수 없어요!\n입력하신 페이지 주소가 정확한지 확인해 주세요.';

  return (
    <PageTemplate>
      <ErrorInfo code={404} message={'존재하지 않은 페이지입니다.'} content={content} />
    </PageTemplate>
  );
};

export default NotFound;
